/* StorageOZ focused search v2026-10-21.1. Native Shopify results, filters and stock remain authoritative. */
(() => {
  'use strict';
  if (window.SOZSearchFocus) return;
  const rule = {"version": "2026-10-21.1", "label": "under sink", "nativeQuery": "\"under sink\"", "aliases": ["under sink", "under-sink", "undersink", "under sink storage", "under-sink storage", "under sink organiser", "under sink organizer", "under sink organisers", "under sink organizers", "under sink rack", "under sink racks"], "collection": "/collections/under-sink-storage", "guide": "/pages/under-sink-storage-solutions"};
  function normalized(value) {
    return String(value || '').trim().toLowerCase().replace(/[\u2010-\u2015]/g, '-').replace(/\s+/g, ' ');
  }
  function resolve(value) {
    const term = normalized(value);
    return term === rule.nativeQuery || rule.aliases.includes(term) ? rule : null;
  }
  function query(value) { return resolve(value)?.nativeQuery || value; }
  function url(value) {
    const result = new URL(value, window.location.origin);
    if (result.origin !== window.location.origin || !/\/search\/?$/.test(result.pathname)) return result;
    const focus = resolve(result.searchParams.get('q'));
    if (focus) {
      result.searchParams.set('q', focus.nativeQuery);
      result.searchParams.set('type', 'product');
      result.searchParams.set('options[prefix]', 'none');
    }
    return result;
  }
  window.SOZSearchFocus = { version: rule.version, resolve, query, url };
  // Direct links and non-form search entry points share the same rule.
  if (/\/search\/?$/.test(window.location.pathname)) {
    const current = new URL(window.location.href);
    const focus = resolve(current.searchParams.get('q'));
    const focusedUrl = focus ? url(current) : current;
    if (focus && focusedUrl.href !== current.href) {
      window.location.replace(focusedUrl.href);
    }
  }
  // Keep native GET submission and its ordinary browser history behavior.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const action = new URL(form.action, window.location.origin);
    if (action.origin !== window.location.origin || !/\/search\/?$/.test(action.pathname)) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || !resolve(input.value)) return;
    input.value = query(input.value);
    const prefix = form.querySelector('input[name="options[prefix]"]');
    if (prefix) prefix.value = 'none';
  }, true);
})();
